import { render, staticRenderFns } from "./TeamSelector.vue?vue&type=template&id=58215132&scoped=true&lang=html&"
import script from "./TeamSelector.vue?vue&type=script&lang=js&"
export * from "./TeamSelector.vue?vue&type=script&lang=js&"
import style0 from "./TeamSelector.vue?vue&type=style&index=0&id=58215132&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58215132",
  null
  
)

export default component.exports